// ErrorBoundary.js
import React from 'react';


class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Errore:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Gestisci l'oggetto errore correttamente
      const errorMessage = this.state.error?.response?.data 
        ? JSON.stringify(this.state.error.response.data)
        : this.state.error?.message || 'Errore sconosciuto';
      
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h2>Errore</h2>
          <p>{errorMessage}</p>
          <button onClick={() => window.location.reload()}>
            Ricarica
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}


export default ErrorBoundary;